import DismissButton from 'components/dismiss-button'
import styles from 'css/components/lesson-builder/student-logins-overlay.module.css'
import { Class } from '@all-for-one/shared-types'
import navLogo from 'img/logo_main-cropped.svg'

interface StudentLoginsOverlayProps {
    classData: Class
    onDismiss: () => void
}

export const StudentLoginsOverlay = ({ classData, onDismiss }: StudentLoginsOverlayProps) => {
    const students = classData?.students || []
    const classPassword = (classData?.defaultPassword || 'afo').trim()

    const handlePrint = () => {
        document.body.classList.add('printing-logins')
        window.print()
        document.body.classList.remove('printing-logins')
        onDismiss()
    }

    return (
        <div className="overlay">
            <div className={`overlay-content-container ${styles.container}`}>
                <div className={styles.printHeader}>
                    <img src={navLogo} alt="All for One" className={styles.printLogo} />
                </div>
                <div className="overlay-content-header">
                    Student Logins - {classData?.name}
                    <DismissButton onClick={onDismiss} />
                </div>
                <div className={styles.content}>
                    <div className={styles.passwordSection}>
                        <div className={styles.classNameRow}>
                            <span className={styles.passwordLabel}>Class:</span>
                            <span className={styles.className}>{classData?.name}</span>
                        </div>
                        <div className={styles.passwordRow}>
                            <span className={styles.passwordLabel}>Class Password:</span>
                            <span className={styles.password}>{classPassword}</span>
                        </div>
                    </div>

                    <div className={styles.tableContainer}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>Student Name</th>
                                    <th>User ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {students.map((student) => (
                                    <tr key={student.studentId}>
                                        <td className={styles.studentName}>{student.studentName?.trim()}</td>
                                        <td className={styles.studentId}>{student.studentId?.trim()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={styles.footer}>
                    <button className={styles.printButton} onClick={handlePrint}>
                        Print List
                    </button>
                    <div className={styles.hint}>
                        Project or print this screen to help students log in
                    </div>
                </div>
            </div>
        </div>
    )
}
